import { withNamespaces } from 'react-i18next';

import { BidVerificationProgressStates } from '../constants';

const completedStates = ['completed'];
const connectedNextStates = ['completed', 'in_progress', 'issues'];

const VerificationProgress = ({
    t,
    stages = [],
}) => {
    return (
        <div className="onboarding-progress">
            {stages.map(({ stage, state }, index) => {
                const stateInfos = BidVerificationProgressStates[state];
                const isConnected = completedStates.includes(state)
                    && connectedNextStates.includes(stages[index + 1]?.state);
                const title = stateInfos.replaceTitle ? stateInfos.title : stage;

                return (
                    <div
                        className={`onboarding-stage${isConnected ? ' connected' : ''}`}
                        key={stage}
                        title={t(stateInfos.title)}
                    >
                        <i className={`stage-icon ${stateInfos.icon} ${stateInfos.className}`} />

                        <span className={`stage-title ${stateInfos.replaceTitle ? stateInfos.className : ''}`}>
                            {t(title)}
                        </span>
                    </div>
                );
            })}
        </div>
    );
};

export default withNamespaces()(
    VerificationProgress
);
